import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { EventsService } from '../../../events.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-crossfire',
  templateUrl: './crossfire.component.html',
  styleUrls: ['./crossfire.component.css']
})
export class CrossfireComponent implements OnInit {

  gameName = "crossfire";

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    
  }

 

}
